import Box from '@mui/material/Box';

/**
 * Draws a service icon.
 *
 * The SVG markup arrives from WordPress already drawn, because the paths are
 * defined once in the theme's inc/template-tags.php. Redrawing all seven here
 * would mean the PHP site and the React site could quietly end up with
 * different icons.
 *
 * dangerouslySetInnerHTML is safe here in the way it usually is not: the markup
 * is a fixed string in our own PHP, not anything a visitor can influence.
 */
export default function ServiceIcon({ svg, size = 32, color = 'currentColor' }) {
	if (!svg) {
		return null;
	}

	return (
		<Box
			aria-hidden="true"
			dangerouslySetInnerHTML={{ __html: svg }}
			sx={{
				display: 'inline-flex',
				color,
				'& svg': {
					width: size,
					height: size,
					display: 'block',
				},
			}}
		/>
	);
}
